var map = {
	"./Bayern München.png": 9918,
	"./Benfica.png": 7383,
	"./Borussia Dortmund.png": 8193,
	"./Chelsea.png": 7279,
	"./Club Brugge.png": 5862,
	"./Eintracht Frankfurt.png": 2022,
	"./FC Porto.png": 8257,
	"./Internazionale.png": 3418,
	"./Liverpool.png": 3831,
	"./Manchester City.png": 9850,
	"./Milan.png": 3722,
	"./Napoli.png": 2603,
	"./Paris SG.png": 2335,
	"./RB Leipzig.png": 5377,
	"./Real Madrid.png": 5569,
	"./TBD.png": 254,
	"./Tottenham.png": 413,
	"./champions_icon.png": 994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9464;